import {Usuario} from '../usuario/usuario.model';

export class Grupo{
  id?: number;
  nome?: string;
  responsavel?: Usuario;
  quantidadeDeUsuarios?: number;
  logoBase64?: string;
  logoExtensao?: string;
  uuid?: string;
  ativo?: boolean;
  usuarioCriacao?: string;
  dataCriacao?: Date;
  usuarioAlteracao?: string;
  dataAlteracao?: Date;

  constructor(
    id?: number,
    nome?: string,
    responsavel?: Usuario,
    quantidadeDeUsuarios?: number,
    logoBase64?: string,
    logoExtensao?: string,
    uuid?: string,
    ativo?: boolean
  ) {
    this.id = id;
    this.nome = nome;
    this.responsavel = responsavel ?? new Usuario();
    this.quantidadeDeUsuarios = quantidadeDeUsuarios;
    this.logoBase64 = logoBase64;
    this.logoExtensao = logoExtensao;
    this.uuid = uuid;
    this.ativo = ativo;
  }

}
